import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import './SpinnerButton.css';

// eslint-disable-next-line object-curly-newline
const SpinnerButton = ({ children, dirty, disabled, isLoading, ...props }) => (
  <Button
    disabled={disabled || isLoading || !dirty}
    block
    bsSize="large"
    bsStyle="primary"
    {...props}
  >
    {isLoading && <FontAwesome name="circle-o-notch" spin />}{children}
  </Button>);

SpinnerButton.defaultProps = {
  dirty: true,
  isLoading: false,
  disabled: false,
};

SpinnerButton.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  dirty: PropTypes.bool,
};

export default SpinnerButton;



// WEBPACK FOOTER //
// ./src/components/SpinnerButton/SpinnerButton.jsx